const DEFAULT_MIN_MARKET_ORDER_USDC = 1;
const DEFAULT_MIN_LIMIT_ORDER_SHARES = 5;
const REDUCED_LIMIT_SCALE = 10;

/** deepsage.live / localhost 开发联调：盘口最低金额与限价最少份额降为 1/10 */
export function isReducedTradeOrderLimitsEnv() {
  if (typeof window === 'undefined') return false;
  const host = String(window.location.hostname || '').toLowerCase();
  if (host === 'localhost' || host === '127.0.0.1') return true;
  return host === 'deepsage.live' || host.endsWith('.deepsage.live');
}

/** 市价单最低金额（USDC） */
export const MIN_MARKET_ORDER_USDC = isReducedTradeOrderLimitsEnv()
  ? DEFAULT_MIN_MARKET_ORDER_USDC / REDUCED_LIMIT_SCALE
  : DEFAULT_MIN_MARKET_ORDER_USDC;

/** 限价单最少份额 */
export const MIN_LIMIT_ORDER_SHARES = isReducedTradeOrderLimitsEnv()
  ? DEFAULT_MIN_LIMIT_ORDER_SHARES / REDUCED_LIMIT_SCALE
  : DEFAULT_MIN_LIMIT_ORDER_SHARES;

/** V2 限价买卖不使用联调域名的份额折扣。 */
export function resolveMinLimitOrderShares(pmProtocolVersion) {
  return pmProtocolVersion === 'V2' ? DEFAULT_MIN_LIMIT_ORDER_SHARES : MIN_LIMIT_ORDER_SHARES;
}

/** 加密货币 tap buy 默认/最低金额（USDC） */
export const MIN_CRYPTO_TAP_BUY_USDC = 1;
